/**
 * Mapeia `location` da API (cadastro de PJ) para chaves usadas no LegalPersonForm / AddressForm.
 * Ex.: "CreateLegalPersonRequest.responsibleAddress.street" → "street"
 */
export function mapLegalPersonCreateApiLocation(location) {
    if (!location || typeof location !== 'string') {
        return null;
    }
    const t = location.trim();

    if (t === 'responsiblePhoneNumbers') {
        return 'phones';
    }

    const prefix = 'responsibleAddress.';
    if (t.startsWith(prefix)) {
        const sub = t.slice(prefix.length);
        if (sub === 'state' || sub.startsWith('state.')) {
            return 'stateAbbr';
        }
        const segments = sub.split('.').filter(Boolean);
        return segments.length ? segments[segments.length - 1] : sub;
    }

    const parts = t.split('.').filter(Boolean);
    return parts.length ? parts[parts.length - 1] : t;
}

/** Chaves de erro exibidas em campos específicos do formulário de cadastro de PJ. */
export const LEGAL_PERSON_CREATE_FIELD_KEYS = new Set([
    'name',
    'fantasyName',
    'document',
    'legalStatus',
    'phones',
    'responsibleName',
    'responsibleEmail',
    'responsibleDocument',
    'responsibleBirthdate',
    'zipCode',
    'street',
    'number',
    'complement',
    'district',
    'city',
    'stateAbbr',
    'sendRegistrationNotification',
]);

/**
 * Monta o objeto `errors` a partir da resposta de validação da API.
 * Erros em campos fora do formulário (ex.: password gerada no backend) vão para `submit`.
 */
export function formatLegalPersonCreateApiErrors(apiError, { fieldErrors, additionalMessages }) {
    const out = {};
    const submitParts = [];

    if (apiError.message?.trim()) {
        submitParts.push(apiError.message.trim());
    }
    for (const m of additionalMessages || []) {
        if (m?.trim()) {
            submitParts.push(m.trim());
        }
    }

    for (const [key, msg] of Object.entries(fieldErrors)) {
        if (!msg) continue;
        if (LEGAL_PERSON_CREATE_FIELD_KEYS.has(key)) {
            out[key] = msg;
        } else {
            submitParts.push(msg);
        }
    }

    if (submitParts.length) {
        out.submit = submitParts.join('\n\n');
    }

    return out;
}
